import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';
import * as selectors from 'app/selectors';
import { FINANCE_NUMBER_FORMAT } from 'app/constants';

var SpaceSettingShowForm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;

    updateCurrentSpace(
    {
      settings: JSON.stringify({
        general_settings: model }) },


    {
      key: 'general_settings' });


  }render()
  {
    const {
      fields: { finance_number_format },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <KBFormError err={error} />
          <div className="kb-row">
            <Field name="finance_number_format" component={renderKBSelect}
            className="kb-form-group kb-form-c39 kb-form-alone"

            title="当计算金额出现小数时"
            arrayData={FINANCE_NUMBER_FORMAT} />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const settings = setting.settings || {};
  let setting_value = settings.finance_number_format || 'origin';
  return {
    initialValues: { finance_number_format: setting_value } };

}

const LEGACY_FORM_FIELDS = [
  "finance_number_format"
];

const formConfig = {
  form: 'SpaceSettingShowForm',
  touchOnBlur: false };


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingShowForm', LEGACY_FORM_FIELDS)(SpaceSettingShowForm)));
